import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";

const CreateCategoryModal = ({
  show,
  toggleShow,
  onSave,
  marketOptions = [],
  initialData = null,
  isEditing = false,
  isSuperAdmin = false,
}) => {
  const [name, setName] = useState("");
  const [market, setMarket] = useState("");
  const [errors, setErrors] = useState({});
  const [disabledMarket, setDisabledMarket] = useState(false);

  useEffect(() => {
    if (initialData) {
      setName(initialData.name || "");
      setMarket(initialData.market || "");
    } else {
      setName("");
      setMarket("");
    }
    // disable market when editing, or when user is not super admin (create flow)
    if (isEditing) {
      setDisabledMarket(true);
    } else {
      setDisabledMarket(!isSuperAdmin);
    }
    // if (!isSuperAdmin) {
    //   setDisabledMarket(true);
    // }
    setErrors({});
  }, [initialData, show, isEditing, isSuperAdmin]);

  const validate = () => {
    const errs = {};
    if (!name || name.trim() === "") errs.name = "Name is required";
    if (!market || market === "") errs.market = "Market is required";
    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const handleSave = () => {
    if (!validate()) return;
    const payload = { name: name.trim(), market };
    if (isEditing && initialData && initialData.id) payload.id = initialData.id;
    if (onSave) onSave(payload);
  };

  return (
    <Modal show={show} onHide={toggleShow} centered>
      <Modal.Header closeButton>
        <Modal.Title>{isEditing ? "Edit Category" : "Create Category"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId="categoryName" className="mb-3">
            <Form.Label>Name *</Form.Label>
            <Form.Control
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Category Name"
              isInvalid={!!errors.name}
            />
            <Form.Control.Feedback type="invalid">{errors.name}</Form.Control.Feedback>
          </Form.Group>

          <Form.Group controlId="categoryMarket" className="mb-3">
            <Form.Label>Market *</Form.Label>
            <Form.Select
              value={market}
              onChange={(e) => setMarket(e.target.value)}
              isInvalid={!!errors.market}
              disabled={disabledMarket}
            >
              <option value="">Select Market</option>
              {marketOptions.map((m) => (
                <option key={m.value || m} value={m.value || m}>
                  {m.displayName || m}
                </option>
              ))}
            </Form.Select>
            <Form.Control.Feedback type="invalid">{errors.market}</Form.Control.Feedback>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={toggleShow}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSave}>
          {isEditing ? "Save" : "Create category"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CreateCategoryModal;
